<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="6">
              <v-select
                :items="exams"
                v-model="exam"
                label="Chọn kỳ thi"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                clearable
                hide-details
                @change="examSelected"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="rooms"
                v-model="room"
                label="Chọn phòng thi"
                item-value="id"
                item-text="name"
                return-object
                clearable
                outlined
                dense
                hide-details
                class="pr-6"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {},
  data() {
    return {
      exam: null,
      room: null,
      exams: [],
      subjects: [],
      rooms: [],
      teacher: {}
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('room', ['fetchRooms']),
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('teacherExam', ['fetchTeacherExams']),
    onFilterChanged() {
      const params = {
        exam: this.exam.id,
        room: this.room ? this.room.id : ''
      }
      this.$emit('onFilterChanged', params, this.room, this.teacher, this.subjects)
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    async getRooms(query) {
      this.rooms = await this.fetchRooms(query)
    },
    async getSubjects(query) {
      this.subjects = await this.fetchSubjects(query)
    },
    async examSelected() {
      this.$loading.active = true
      await this.getSubjects({ exam: this.exam ? this.exam.id : '' })
      await this.getRooms({ exam: this.exam ? this.exam.id : '' })

      if (this.$auth.role.type === 'teacher') {
        const teacherExam = await this.fetchTeacherExams({ teacher: this.$auth.user.teacher, exam: this.exam.id })

        if (teacherExam.length === 0) {
          this.teacher = null
          this.rooms = []
          this.subjects = []
        } else {
          this.teacher = teacherExam[0]

          this.rooms = this.rooms.filter(room => this.teacher.rooms.some(teacherRoom => teacherRoom.id === room.id))
          this.subjects = this.subjects.filter(subject =>
            this.teacher.subjects.some(teacherSubject => teacherSubject.id === subject.id)
          )
        }
      }

      this.room = null
      this.$loading.active = false
    }
  }
}
</script>
